import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import FirestoreService from '../assets/js/firestore_instance';

const AuthCheck = ({ children, navigateTo }) => {
  const navigate = useNavigate();
  const auth = getAuth();
  const db = FirestoreService.getFirestore();

  useEffect(() => {
    const checkAuthState = async () => {
      onAuthStateChanged(auth, async (user) => {
        if (user) {
          try {
            const userDocRef = doc(db, "admin_users", user.uid);
            const docSnap = await getDoc(userDocRef);
            
            if (docSnap.exists()) {
              if (navigateTo === 'dashboard') {
                navigate('/dashboard');
              }
            } else {
              navigate('/sign-in');
            }
          } catch (error) {
            console.error("Error checking user document:", error);
            navigate('/sign-in');
          }
        }
      });
    };

    checkAuthState();
  }, [auth, db, navigate, navigateTo]);

  return children;
};

export default AuthCheck;